import { isProductExecutive, isTeamManager, type Role } from "@packages/core/session/roles.ts";

export const OFFICEVIBE_SURVEY_CREATE_ACCESS: readonly Role[] = [isProductExecutive("wov"), isTeamManager];
